export const enum ShowingApiEmbed {
    /** @deprecated fetching movie by id in a separate request instead for v2 endpoint */
    Cinema = 'cinema',
    /** @deprecated  fetching cinema room by id in a separate request instead */
    CinemaRoom = 'cinemaRoom'
}
